import { Options, Ref, Vue } from "vue-property-decorator";

@Options({
  props: {
    statusList: Object,
  },
  components: {}
})
export default class MultiSelectFilterStatus extends Vue {

  private statusList!: any[];

  private selectedStatus: any[] = [];

  private showMultiSelect = false;

  private finalSelectedStatus: any[] = [];

  @Ref('dropDownSelectStatus')
  private dropDownSelectUI!: HTMLElement;

  created(): void {
    window.addEventListener('click', this.clickedElement);
  }

  beforeUnmount(): void {
    window.removeEventListener('click', this.clickedElement);
  }

  private clickedElement(e: MouseEvent): void | boolean {
    const el: HTMLElement = this.dropDownSelectUI;
    const rect = el.getBoundingClientRect();
    if (e.pageX >= rect.left && e.pageX <= rect.right && e.pageY >= rect.top && e.pageY <= rect.bottom + 300) {
      return true;
    } else {
      this.showMultiSelect = false;
    }

  }

  mounted(): void {
    // select 'All' by default
    this.selectAllStatus();
  }

  private selectAllStatus() {
    // select 'All' by default
    this.finalSelectedStatus = [];
    if (this.statusList.length > 0) {
      for (let i = 0; i < this.statusList.length; i++) {
        this.selectedStatus.push(this.statusList[i]);
        this.selectedStatus[i].disabled = false;
        if (i === this.statusList.length - 1) {
          // for the completed status, uncheck it by default
          this.selectedStatus[i].selected = false;
        } else {
          this.selectedStatus[i].selected = true;
        }
      }

      this.finalSelectedStatus = this.selectedStatus.filter((item: any) => (item.selected === true && item.id > 0));
      this.$emit('selectStatus', this.finalSelectedStatus);
    }
  }

  private onSelectedStatusChanged(index: number) {
    this.selectedStatus[index].selected = !this.selectedStatus[index].selected;

    const allSelected = this.selectedStatus.some(item => item.name === 'All' && item.selected);
    const completedSelected = this.selectedStatus.some(item => index === (this.selectedStatus.length - 1) && item.selected);
    if (index === this.selectedStatus.length - 1) {
      if (completedSelected) {
        this.selectedStatus.forEach((item, i) => {
          item.selected = i === this.selectedStatus.length - 1;
          item.disabled = i !== this.selectedStatus.length - 1;
        });
      } else {
        this.selectedStatus = [];
        this.selectAllStatus();
      }
    } else {
      this.selectedStatus.slice(0, -1).forEach(item => (item.disabled = false));

      if (index === 0) {
        if (allSelected) {
          this.selectedStatus = [];
          this.selectAllStatus();
        } else {
          this.selectedStatus.forEach((item, i) => {
            if (i !== 0) {
              item.selected = false;
            }
          });
        }
      } else {
        this.selectedStatus[0].selected = false;
        this.finalSelectedStatus = this.selectedStatus.slice(1).filter(item => item.selected && item.id > 0);
        if (this.finalSelectedStatus.length === this.statusList.length - 2 && allSelected) {
          this.selectedStatus[0].selected = false;
        }
      }
    }

    this.finalSelectedStatus = this.selectedStatus.filter(item => item.selected && item.id > 0);
    this.$emit('selectStatus', this.finalSelectedStatus);
  }


  private toggleMultiSelect() {
    this.showMultiSelect = !this.showMultiSelect;
  }

  get selectedStatusText() {
    const completedSelected = this.selectedStatus.some(item => item.name === 'Completed' && item.selected);
    const allSelected = this.selectedStatus.some(item => item.name === 'All' && item.selected);

    if (completedSelected) {
      return 'Completed';
    } else if (allSelected) {
      return 'All except Completed';
    } else if (this.finalSelectedStatus.length > 0) {
      return this.finalSelectedStatus.map(item => item.name).join(', ');
    } else {
      return 'No status selected';
    }
  }


}


